import { store } from '@/store';
import { SeamlessConnection } from '@seamless/store';
import { Reducer } from 'redux';
import { AnyAction } from '.';

export const OWC_PERSONALISATION_CONNECTION = 'OWC_PERSONALISATION_DATA';

export enum personalisationDispatchers {
  addPersonalisationData = 'addPersonalisationData',
}

export type OWCPersonalisationState = OWCPersonalisationData[];

export type OWCPersonalisationData = {
  componentId: string;
  personalisationData: unknown;
};

const initialState: OWCPersonalisationState = [];

export type OWCPersonalisationDispatchers = {
  addPersonalisationData: (data: OWCPersonalisationData) => AnyAction;
};
export class OWCPersonalisationConnection extends SeamlessConnection<
  OWCPersonalisationDispatchers,
  OWCPersonalisationState
> {
  constructor() {
    super(OWC_PERSONALISATION_CONNECTION);
  }

  get initialState(): OWCPersonalisationState {
    return initialState;
  }

  getReducer(): Reducer {
    return (state: OWCPersonalisationState, action: AnyAction) => {
      if (action.type === this.getActionType(personalisationDispatchers.addPersonalisationData)) {
        state.push(action.payload);
        return [...state];
      }
      return state;
    };
  }

  getPublicDispatchers(): OWCPersonalisationDispatchers {
    return {
      addPersonalisationData: (payload: OWCPersonalisationData) =>
        this.getAction(personalisationDispatchers.addPersonalisationData, payload),
    };
  }
}

export const addPersonalisationConnection = () => store.addConnection(new OWCPersonalisationConnection());
